import { useEffect, useRef } from "react";

export function useFireOnceWhenReady(isReady, onReady, resetKey) {
  const firedRef = useRef(false);
  const onReadyRef = useRef(onReady);

  useEffect(() => {
    onReadyRef.current = onReady;
  }, [onReady]);

  useEffect(() => {
    firedRef.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetKey]);

  useEffect(() => {
    if (isReady && !firedRef.current) {
      firedRef.current = true;
      onReadyRef.current?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady, resetKey]);
}

export default useFireOnceWhenReady;
